module.exports = __webpack_public_path__ + "../resources/images/emptyInbox-383cff1a8febb38361fbfcb35e611db1.svg";